import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { SELECTED_BORDER, shadows } from 'src/config/styles'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  root: {
    borderRadius: 8,
    padding: [22, 24],
    boxShadow: shadows[3],
    ...typography['Lato H5 Bold'],
    cursor: 'pointer',
    [forPhoneOnly]: {
      ...typography['Lato Emphasized 1'],
      padding: [14, 16],
    },
  },
  selected: {
    border: SELECTED_BORDER(theme),
    background: theme.palette.grey[100],
  },
}))
